import React from 'react';
import { Tooltip as ReactTippy, TooltipProps } from 'react-tippy';

type Props = TooltipProps & {
  id?: string;
  children?: React.ReactNode;
};

const Tooltip: React.FC<Props> = ({ children, ...props }) => {
  const TippyWithChildren = ReactTippy as React.ComponentType<Props>;

  return <TippyWithChildren {...props}>{children}</TippyWithChildren>;
};

export default Tooltip;
